import { type IRootWidgetIdentifier } from '../TreeReferencesGlobalContext.tsx';

/**
 * Set minimo di proprietà che devono essere presenti in un oggetto
 * da passare alla funzione getAllRoots.
 *
 * Creata sulla base di SezioneDTO, non presente in engine ma solo in web.
 */
interface GetAllRootParams {
  ultimaVersione?: {
    elementi?: any | null;
    id?: string | null;
  } | null;
}

/**
 * Trasforma la lista delle sezioni di un form in una lista di root identifier.
 */
export function getAllRoots(
  allSections: GetAllRootParams[] | null | undefined,
): IRootWidgetIdentifier[] {
  if (!allSections) return [];
  return allSections
    .filter(
      s => s.ultimaVersione?.elementi != null && s.ultimaVersione?.id != null,
    )
    .map(s => ({
      id: s.ultimaVersione!.id!,
      type: 'section',
      root: s.ultimaVersione!.elementi!,
    }));
}
